import React, { useContext } from 'react';
import { object } from 'prop-types';

import { useTranslate } from '../../translate/I18n';
import { historyPushWithParams } from '../../utils/utils';
import { UserContext } from '../auth/hook/userContext';

import Box from '../atoms/Box';
import Card from '../atoms/Card';
import Text from '../atoms/Text';

import User from '../atoms/icons/User';
import Suitcase from '../atoms/icons/Suitcase';

import { commonRoutes } from '../../routes';
import { ROLES } from '../../constants';
import FaqQuestions from './FaqQuestions';
import { useParams, useRouter } from '../../utils/router';
import { getQuestionsByCategoryFromNamespace } from './faqUtils';
import { useTerritory } from '../../hooks/useTerritory';

const { general } = commonRoutes;
const { FREELANCE, COMPANY } = ROLES;

const Faq = () => {
  const history = useRouter();
  const { role } = useParams();
  const { t } = useTranslate(['faq']);
  const user = useContext(UserContext);
  const territory = useTerritory();

  const questionsByCategory = getQuestionsByCategoryFromNamespace(t, `faq:content:${role}`);

  return (
    <Box textAlign="center">
      <Text tag="h1" styleName="wH2" mt={8}>
        {t('faq:title')}
      </Text>
      {!user.isLogged && <Text mt={2}>{t('faq:undertitle')}</Text>}
      <Box display="flex" my={6} justifyContent="center">
        <Card
          style={{ cursor: 'pointer' }}
          p={4}
          mr={{ _: 2, md: 5, xl: 10 }}
          onClick={() => historyPushWithParams(history, general.faq.to, { role: FREELANCE })}
          highlight={role === FREELANCE}
          data-cy={`faq-freelancer-${territory.name}`}>
          <User fontSize="24px" color={role === FREELANCE ? 'blue' : 'dark'} />
          <Text mt={1} styleName="wH4">
            {t('faq:forFreelancers')}
          </Text>
        </Card>
        <Card
          style={{ cursor: 'pointer' }}
          p={4}
          onClick={() => historyPushWithParams(history, general.faq.to, { role: COMPANY })}
          highlight={role === COMPANY}
          data-cy={`faq-company-${territory.name}`}>
          <Suitcase fontSize="24px" color={role === COMPANY ? 'blue' : 'dark'} />
          <Text mt={1} styleName="wH4">
            {t('faq:forCompanies')}
          </Text>
        </Card>
      </Box>

      <Box maxWidth="920px" textAlign="left" mx="auto" px={2} mb={6}>
        {[FREELANCE, COMPANY].includes(role) && <FaqQuestions questionsByCategory={questionsByCategory} />}
      </Box>
    </Box>
  );
};

Faq.propTypes = {
  history: object
};

export default Faq;
